import axios from '@/utils/request'
const urlPrefix = 'map'
/// ///////////////////////////////////////视点//////////////////////////////////////////
// 新建视点数据
export function addViewPoint (data) {
  return axios({
    url: urlPrefix + '/map/viewpoint',
    method: 'post',
    data: data
  })
}
// 更新视点
export function updateViewPoint (data) {
  return axios({
    url: urlPrefix + '/map/viewpoint',
    method: 'put',
    data: data
  })
}
// 删除视点
export function delViewPoint (data) {
  return axios({
    url: urlPrefix + '/map/viewpoint',
    method: 'delete',
    data: data
  })
}
// 获取单个视点详细信息
export function getViewPoint (params) {
  return axios({
    url: urlPrefix + '/map/viewpoint',
    method: 'get',
    params: params
  })
}
// 获取视点列表信息
export function getViewPointList (params) {
  return axios({
    url: urlPrefix + '/map/viewpoint/list',
    method: 'get',
    params: params
  })
}
// 获取默认视点
export function getDefaultViewPoint (params) {
  return axios({
    url: urlPrefix + '/map/viewpoint/default',
    method: 'get',
    params: params
  })
}
// 获取常用视点
export function getFrequentlyViewPoint (params) {
  return axios({
    url: urlPrefix + '/map/viewpoint/list/frequently',
    method: 'get',
    params: params
  })
}
/// ///////////////////////////////////////动画//////////////////////////////////////////
// 新建动画数据
export function addViewAnimation (data) {
  return axios({
    url: urlPrefix + '/map/viewpoint/animation',
    method: 'post',
    data: data
  })
}
// 更新动画
export function updateViewAnimation (data) {
  return axios({
    url: urlPrefix + '/map/viewpoint/animation',
    method: 'put',
    data: data
  })
}
// 删除动画
export function delViewAnimation (data) {
  return axios({
    url: urlPrefix + '/map/viewpoint/animation',
    method: 'delete',
    data: data
  })
}
// 获取单个动画详细信息
export function getViewAnimation (params) {
  return axios({
    url: urlPrefix + '/map/viewpoint/animation',
    method: 'get',
    params: params
  })
}
// 获取动画列表信息
export function getViewAnimationList (params) {
  return axios({
    url: urlPrefix + '/map/viewpoint/animation/list',
    method: 'get',
    params: params
  })
}
// 获取默认动画
export function getDefaultAnimation (params) {
  return axios({
    url: urlPrefix + '/map/viewpoint/animation/default',
    method: 'get',
    params: params
  })
}
// 获取常用动画
export function getFrequentlyAnimation (params) {
  return axios({
    url: urlPrefix + '/map/viewpoint/animation/list/frequently',
    method: 'get',
    params: params
  })
}
